import { Controller, useFormContext } from 'react-hook-form';
import { MarkerPin01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step08Estado = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="estado"
      render={({ field }) => (
        <Input
          label="Estado (UF)"
          type="text"
          size={AUTH_FORM_SIZE}
          icon={MarkerPin01}
          placeholder="MS"
          autoComplete="address-level1"
          autoFocus
          maxLength={2}
          inputClassName="uppercase tracking-[0.2em]"
          isInvalid={!!errors.estado}
          hint={errors.estado?.message}
          value={field.value ?? ''}
          onChange={(next) => field.onChange(typeof next === 'string' ? next.toUpperCase() : next)}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
